import { formatPrice } from 'utils/helpers';
import { dealPriceLimits } from 'utils/deals';
import { useListQuery as useDealsQuery } from 'store/api/deal';

import * as Styles from './styles';

interface DealMinimumWarningProps {
  productId?: number;
  minPrice?: number | string;
  retailPrice?: number | string;
}

// POS Deals (owner, 26 Oct 2026): a new minimum that puts a deal below its
// products' minimums is shown before saving. Saving is still allowed; the deal
// then shows "Below minimums" and the register refuses it until the office
// updates its price.
export const DealMinimumWarning = ({
  minPrice,
  productId,
  retailPrice,
}: DealMinimumWarningProps) => {
  const { data: deals = [] } = useDealsQuery(
    { productId },
    { skip: !productId }
  );

  const under = deals.flatMap((deal) => {
    const { minPrice: floor } = dealPriceLimits(
      deal.products.map(({ count, product }) => ({
        count: Number(count),
        minPrice: product?.id === productId ? minPrice : product?.minPrice,
        retailPrice:
          product?.id === productId ? retailPrice : product?.retailPrice,
      }))
    );
    const gap = floor - Number(deal.salePrice);
    return gap > 0 ? [{ gap, name: deal.name }] : [];
  });

  if (!under.length) {
    return null;
  }

  return (
    <Styles.DealWarning>
      {under.map(({ gap, name }) => (
        <p key={name}>
          This puts deal {name} {formatPrice(gap)} under its minimums.
        </p>
      ))}
    </Styles.DealWarning>
  );
};
